import moment from 'moment';

const periodValues = {
    current: moment().toDate(),
    prevDate: moment().subtract(1, 'day').toDate(),
    days30: moment().subtract(29, 'day').toDate(),
    weekStart: moment().startOf('week').toDate(),
    weekEnd: moment().endOf('week').toDate(),
    nextWeekStart: moment().add(1, 'week').startOf('week').toDate(),
    nextWeekEnd: moment().add(1, 'week').endOf('week').toDate(),
    prevWeekStart: moment().subtract(1, 'week').startOf('week').toDate(),
    prevWeekEnd: moment().subtract(1, 'week').endOf('week').toDate(),
    prevMonthStart: moment().subtract(1, 'month').startOf('month').toDate(),
    prevMonthEnd: moment().subtract(1, 'month').endOf('month').toDate(),
    yearStart: moment().startOf('year').toDate(),
    monthStart: moment().startOf('month').toDate(),
};

export const SHORT_DATE_FORMAT_SHORT_YEAR = 'MM/DD/YY';
export const XUX_DATEPICKER_PERIODS = {
    PERIODS: {
        name: 'Period',
        id: 'periods',
        type: 'periods',
        value: null
    },

    PREVIOUS_PERIOD: {
        name: 'Previous Period',
        id: 'previous_period',
        type: 'periods',
    },

    CURRENT_PERIOD: {
        name: 'Current Period',
        id: 'current_period',
        type: 'periods',
    },

    PERIODS_WEEK: {
        name: 'Period / Week',
        id: 'periods_week',
        type: 'periodsWeek',
    },

    CURRENT_DATE: {
        name: 'Current Date',
        id: 'current',
        type: 'range',
        value: {
            dateStart: periodValues.current,
            dateEnd: periodValues.current,
        },
    },

    SINGLE: {
        name: 'Single',
        id: 'single',
        type: 'single',
    },

    PREVIOUS_DATE: {
        name: 'Previous Date',
        id: 'prev_date',
        type: 'range',
        value: {
            dateStart: periodValues.prevDate,
            dateEnd: periodValues.prevDate,
        },
    },

    DAYS30: {
        name: 'Last 30 Days',
        id: '30days',
        type: 'range',
        value: {
            dateStart: periodValues.days30,
            dateEnd: periodValues.current,
        },
    },

    PREVIOUS_MONTH: {
        name: 'Previous Month',
        id: 'prev_month',
        type: 'range',
        value: {
            dateStart: periodValues.prevMonthStart,
            dateEnd: periodValues.prevMonthEnd,
        },
    },

    PERIODS_YEAR: {
        name: 'This Year',
        id: 'this_year',
        type: 'range',
        value: {
            dateStart: periodValues.yearStart,
            dateEnd: periodValues.current,
        },
    },

    PERIODS_MONTH: {
        name: 'This Month',
        id: 'this_month',
        type: 'range',
        value: {
            dateStart: periodValues.monthStart,
            dateEnd: periodValues.current,
        },
    },

    WEEK: {
        name: 'This Week',
        id: 'current_week',
        type: 'range',
        value: {
            dateStart: periodValues.weekStart,
            dateEnd: periodValues.current,
        },
    },

    NEXT_WEEK: {
        name: 'Next Week',
        id: 'next_week',
        type: 'range',
        value: {
            dateStart: periodValues.nextWeekStart,
            dateEnd: periodValues.nextWeekEnd,
        },
    },

    PREV_WEEK: {
        name: 'Previous Week',
        id: 'previous_week',
        type: 'range',
        value: {
            dateStart: periodValues.prevWeekStart,
            dateEnd: periodValues.prevWeekEnd,
        },
    },

    FULL_CURRENT_WEEK: {
        name: 'Current Week',
        id: 'full_current_week',
        type: 'range',
        value: {
            dateStart: periodValues.weekStart,
            dateEnd: periodValues.weekEnd,
        },
    },

    CUSTOM: {
        name: 'Custom',
        id: 'custom',
        type: 'range',
    },

    LATEST_BUSINESS_DATE: {
        name: 'Latest Business Date',
        id: 'latest_business_date',
        type: 'range',
        value:  {
            dateStart: periodValues.prevDate,
            dateEnd: periodValues.prevDate,
        }
    }
};

export enum DateGranularity {
    DAY = 'day',
    MONTH = 'month',
    YEAR = 'year',
}
